
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/paymaster/[...slug]",
      function () {
        return require("private-next-pages/paymaster/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/paymaster/[...slug]"])
      });
    }
  